import React from 'react'
import * as bie from "react-bootstrap";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { Button } from 'react-bootstrap';


export default function CommonFormHeading({ heading }, sub1, sub2, sub3) {

    return (<>

        <bie.Container fluid className="px-1" >
            <bie.Row className='m-0'>

                <bie.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className="dite pt-3">
                    <div className='d-flex align-items-center justify-content-between'>
                        <Breadcrumb>
                            <Breadcrumb.Item href="/dashboard">Home</Breadcrumb.Item>
                            {/* <Breadcrumb.Item href="">
                                AAP
                            </Breadcrumb.Item> */}
                            <Breadcrumb.Item active>{heading}</Breadcrumb.Item>
                        </Breadcrumb>
                        <Button className='btn btn-secondary mb-3' href="/dashboard">
                            home
                        </Button>
                    </div>
                </bie.Col>
            </bie.Row>
        </bie.Container>
    </>)
}

